module.exports = __webpack_public_path__ + "img/gb9115_24_c.prt.ac8c506a.jpg";